import React, { useState } from 'react';

import Summary from './Summary'
import CodeEditor from './CodeEditor'
import 'highlight.js/styles/atom-one-light.css'


function buildComment(currentStep, baseCode) {
  return `# Challenge ${currentStep+1}/${baseCode.length}: ${baseCode[currentStep][0]}`
}

function getNoise(currentStep, baseCode) {
  return baseCode[currentStep][2] || []
}

function getResources(currentStep, baseCode) {
  if (baseCode[currentStep] === undefined) {
    return []
  }
  return baseCode[currentStep][3] || []
}


let issuesFixed = 0
let totalIssues = 0
let issuesMissed = []


export default function Challenge(props) {
  const [currentStep, setCurrentStep] = useState(0)
  const [userCode, setUserCode] = useState(props.baseCode[0][1])
  const [conclusion, setConclusion] = useState(undefined)
  const [validationError, setValidationError] = useState()
  const [isInProgress, setIsInProgress] = useState(false)

  function handleSubmitAdvice() {
    setIsInProgress(true)
    setValidationError(undefined)

    const noise = getNoise(currentStep, props.baseCode)
    const queryString = new URLSearchParams()
    queryString.append('base_code', encodeURIComponent(props.baseCode[currentStep][1].trim()))
    queryString.append('user_code', encodeURIComponent(userCode.trim()))
    queryString.append('filepath', encodeURIComponent(props.filepath))
    queryString.append('noise', encodeURIComponent(noise))

    fetch(`${process.env.REACT_APP_CHALLANGE_ADVICE_URL}?${queryString}`, {
        method: "GET",
        headers: {"Content-Type": "application/json"},
      }).then(result => {
        if (result.ok) {
          result.json().then(parsed => {
            for (var item of parsed.doctor_user_code_advice) {
              // hack to make the diff numbering play nice in <Advice>
              if (item.diff) {
                item.diff.before[0][0] += 1
                item.diff.after[0][0] += 1
              }
            }
            issuesFixed += Math.max(parsed.doctor_base_code_advice.length - parsed.doctor_user_code_advice.length, 0)
            totalIssues += parsed.doctor_base_code_advice.length

            for (var advice of parsed.doctor_user_code_advice) {
              if (!issuesMissed.includes(advice['message-id'])) {
                issuesMissed.push(advice['message-id'])
              }
            }
            setConclusion({
              baseCodeAdvice: parsed.doctor_base_code_advice,
              userCodeAdvice: parsed.doctor_user_code_advice,
              transformed: undefined,
              userCodeBeforeFix: undefined,
              transformMessageIds: undefined,
            })
          })
        } else {
          result.json().then(parsed => {
            setConclusion(undefined)
            setValidationError(parsed.error)
          })
        }
      })
      .finally(() => {
        setIsInProgress(false)
      })
  }

  function handleSubmitTransform() {
    setIsInProgress(true)

    const noise = getNoise(currentStep, props.baseCode)
    const queryString = new URLSearchParams()
    queryString.append('user_code', encodeURIComponent(userCode.trim()))
    queryString.append('filepath', encodeURIComponent(props.filepath))
    queryString.append('noise', encodeURIComponent(noise))

    fetch(`${process.env.REACT_APP_CHALLANGE_TRANSFORM_URL}?${queryString}`, {
        method: "GET",
        headers: {"Content-Type": "application/json"},
      }).then(result => {
        if (result.ok) {
          result.json().then(parsed => {
            setUserCode(parsed.transformed)
            setConclusion({
              userCodeBeforeFix: userCode,
              transformMessageIds: parsed.message_ids,
              baseCodeAdvice: undefined,
              userCodeAdvice: undefined,
            })

            totalIssues += parsed.message_ids.length

            for (var message_id of parsed.message_ids) {
              if (!issuesMissed.includes(message_id)) {
                issuesMissed.push(message_id)
              }
            }

          })
        } else {
          result.json().then(parsed => {
            setConclusion(undefined)
            setValidationError(parsed.error)
          })
        }
      })
      .finally(() => {
        setIsInProgress(false)
      })
  }

  function handleNextClick() {
    const next = currentStep + 1
    if (next !== props.baseCode.length) {
      setUserCode(props.baseCode[next][1])
    }
    setCurrentStep(next)
    setConclusion(undefined)
  }

  const resources = getResources(currentStep, props.baseCode)

  if (currentStep === props.baseCode.length) {
    return <Summary
      messageIds={issuesMissed}
      issuesFixed={issuesFixed}
      totalIssues={totalIssues}
      showMini={props.showMiniSummary}
    />
  } else {
    return <CodeEditor
      autoFocus={props.aut}
      comment={buildComment(currentStep, props.baseCode)}
      diffBefore={conclusion && conclusion.userCodeBeforeFix}
      diffMessageIds={conclusion && conclusion.transformMessageIds}
      filepath={props.filepath}
      isInProgress={isInProgress}
      isLastQuestion={currentStep === props.baseCode.length - 1}
      messages={conclusion && conclusion.userCodeAdvice && conclusion.userCodeAdvice.filter(item => item.message_type === 'message_centric')}
      onFixClick={handleSubmitTransform}
      onNextClick={handleNextClick}
      onSaveClick={handleSubmitAdvice}
      onValueChange={setUserCode}
      readOnly={isInProgress}
      validationError={validationError}
      value={userCode}
      resources={resources}
      category={props.category}
      showLinks={props.showLinks}
    />
  }
}

Challenge.defaultProps = {
  handleShowSubscribe: () => {},
  showLinks: true,
  showMiniSummary: false,
}